var map = {
	"./Dashboard.svg": 2469,
	"./example.svg": 7893,
	"./eye.svg": 8431,
	"./form.svg": 2962,
	"./link.svg": 9835,
	"./nested.svg": 3593,
	"./password.svg": 4117,
	"./table.svg": 5695,
	"./tree.svg": 9162,
	"./user.svg": 7798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;